import { AsyncComponentRender } from '@components/AsyncComponent';
import { getSubdomainData } from '@lib/utils';
import { createDialog } from '@packages/dialog';
import { createMemo } from '@packages/react';
import { createTabs, TabContainer, TabContent } from '@packages/tabs';
import React from 'react';

const TABS = createTabs([
    ['', '', AsyncComponentRender(() => import('./Tabs/SignupView'))],
    ['', '', AsyncComponentRender(() => import('./Tabs/SigninView'))],
]);

const Content = createMemo<any>(
    (props) => {
        const subdomainData = getSubdomainData();
        const site = subdomainData?.company_name || 'GameBreaker';

        const { api, section = site, cartItems, totalAmount, from, onSubmit } = props;

        return (
            <>
                <TabContainer tabs={TABS}>
                    <TabContent
                        activeTabProps={{
                            section: section,
                            platform: site,
                            cartItems: cartItems,
                            totalAmount: totalAmount,
                            from: from,
                            onSubmit: onSubmit,
                            dialogApi: api,
                        }}
                    />
                </TabContainer>
            </>
        );
    },
    {
        displayName: 'AuthContent',
    },
);

export const AuthDialog = createDialog({
    width: '100%',
    maxWidth: 425,
    maxHeight: 595,
    dataProps: ['onSelect', 'section', 'cartItems', 'totalAmount', 'from', 'onSubmit'],
    scroll: 'paper',
    disableBackdropClick: true,
    noToggle: true,
})(Content);
